import { Repository } from "../utils";

// Define interfaces for the response types
interface ConfirmNameResponse {
  status: number;
  message?: string;
}

interface ResetResponse {
  status: number;
  message?: string;
}

interface DeleteResponse {
  status: number;
  message?: string;
}

// Renamed to match UI naming conventions. Backend still uses "projects"
export class CodebaseRepository extends Repository {
  apiUrl = '/api/v1/codebases/';

  async branches(codebaseSlug: string): Promise<string[]> {
    const response = await fetch(
      this.apiUrl + codebaseSlug + "/branches/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 204 || response.headers.get("content-length") === "0") {
      return [];
    }
    return response.status === 200 ? await response.json().then(data => data):[];
  }

  async confirmName(codebaseSlug: string, codebaseName: string, csrfToken: string): Promise<ConfirmNameResponse> {
    return await fetch(
      this.apiUrl + codebaseSlug + "/confirm_name/",
      {
        method: "POST",
        body: JSON.stringify({name: codebaseName}),
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
      }
    );
  }

  async delete(codebaseSlug: string, csrfToken: string): Promise<DeleteResponse> {
    return await fetch(
      this.apiUrl + codebaseSlug + "/",
      {
        method: "DELETE",
        headers: {
          "X-CSRFToken": csrfToken,
        },
      }
    );
  }

  async reset(codebaseSlug: string, csrfToken: string): Promise<ResetResponse> {
    return await fetch(
      this.apiUrl + codebaseSlug + "/reset/",
      {
        method: "POST",
        headers: {
          "X-CSRFToken": csrfToken,
        },
      }
    );
  }
}

// Keep ProjectRepository for backward compatibility
export class ProjectRepository extends CodebaseRepository {}
